import { render, staticRenderFns } from "./ticketterms.vue?vue&type=template&id=24b26638&"
import script from "./ticketterms.vue?vue&type=script&lang=js&"
export * from "./ticketterms.vue?vue&type=script&lang=js&"
import style0 from "./ticketterms.vue?vue&type=style&index=0&id=24b26638&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports